import fingerPrint from '../../assets/bg_fingerprint.png';
import styled from 'styled-components';

export const WrapperDiv = styled.div`
  display: table-cell;
  text-align: center;
  height: calc(100vh - 100px);
  width: 100vw;
  vertical-align: middle;
  background-image: url(${fingerPrint});
  background-repeat: no-repeat;
  background-size: contain;
`;
